import { ChannelType } from 'src/api/generated';
import { Text } from 'src/modules/shared/components/atoms/text';
import { formatPhoneNumber } from 'src/modules/shared/utils/formatting/phone.util';
import { normalizeEmail } from 'src/modules/shared/utils/validation/email.util';
import type { TimelineItemDetailsProps } from '../../../types/timeline/item-actions.types';

/** Minimal metadata content; the surrounding menu provides the dialog affordance. */
export function TimelineItemDetails({
  channel,
  description,
  senderAddress,
  recipientAddress,
  redirectedTo,
  children,
}: TimelineItemDetailsProps) {
  const formatAddress = (value?: string | null) => {
    const raw = value?.trim() ?? '';
    return raw
      ? channel === ChannelType.EMAIL
        ? normalizeEmail(raw) ?? raw
        : formatPhoneNumber(raw)
      : '—';
  };
  return (
    <div className="flex min-w-0 flex-col gap-3 break-words [overflow-wrap:anywhere]">
      <Text size="small" weight="semibold">
        {description}
      </Text>
      <dl className="grid grid-cols-[auto_1fr] gap-x-4 gap-y-2 text-sm">
        <Text as="dt" size="small" color="secondary">
          De
        </Text>
        <Text as="dd" size="small">
          {formatAddress(senderAddress)}
        </Text>
        <Text as="dt" size="small" color="secondary">
          Para
        </Text>
        <Text as="dd" size="small">
          {formatAddress(recipientAddress)}
        </Text>
        {redirectedTo && (
          <>
            <Text as="dt" size="small" color="secondary">
              Redirigida a
            </Text>
            <Text as="dd" size="small">
              {formatAddress(redirectedTo)}
            </Text>
          </>
        )}
      </dl>
      {children}
    </div>
  );
}
